import React from 'react'
import { EnlaceBase, useDiseñoConfig } from './ComponenteBase'

const DiseñoModern = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Obtener configuración del diseño
  const config = useDiseñoConfig('modern', configuracion)

  // Diseño normal para desktop
  return (
    <div className="space-y-3 sm:space-y-4">
      {enlaces.map((enlace, index) => (
        <EnlaceBase
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          configuracion={config}
          className="group"
        />
      ))}
    </div>
  )
}

export default DiseñoModern 